import { useCallback, useMemo, useState } from "react";
import api from "../../../../utils/api";
import { Checkin } from "../../../../types";


export type TVisitante = {
  id: number,
  nome: string,
  email: string,
  telefone: string,
  cadastrado: boolean,
  inscricao: string | Date,
  ministerioGrupo: number
}

export type ResponseMembrosCheckin = {
  listAll: Checkin[] | []
  reset: () => Promise<void>
  nextPagina: VoidFunction
  getWithParams: (params: any) => void
  list: Checkin[]
  pagina: number
  getSearchNome: (event: any) => void
  nome: string
}

const GetMembros = (): ResponseMembrosCheckin => {

  const [listCheckinMembros, setListCheckinMembros] = useState<Checkin[]>([]);
  const [list, setList] = useState<Checkin[]>([]);
  const [pagina, setPagina] = useState<number>(0);
  const [nome, setNome] = useState<string>();

  const getSearchNome = (event: any) => setNome(event?.target?.value);

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const reset = async () => {
      await getList()
  }

  const getWithParams = (params: any) => {
    api.get<Checkin[]>('visitante', { params: { ...params } })
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {

          console.log(error?.response);
        }
      )
  }


  const getList = useCallback(async () => {
    api.get<Checkin[]>('visitante')
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }, []);

  useMemo(() => {
    getList()
  }, [])


  return {
    listAll: listCheckinMembros,
    reset,
    nextPagina,
    list,
    pagina,
    getWithParams,
    getSearchNome,
    nome
  };
}

export default GetMembros;
